import { buttonVariants } from '@ibsys/kit';
import { FC, PropsWithChildren } from 'react';
import { cn } from '@/shared/lib/utils';

type Props = {
  className?: string;
};

/**
 * Компонент для отображения времени сообщения
 */
export const ChatMessageTime: FC<PropsWithChildren<Props>> = ({ children, className }) => {
  if (!children) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex gap-4 items-center',
        buttonVariants({ variant: 'ghost' }),
        'text-xs font-light ml-auto p-2 min-h-0 h-auto no-underline',
        // Цвет времени приходит из темы уже приглушённым — прозрачность здесь не добавляется
        'hover:bg-white-100/10 text-(--chat-time) hover:text-(--chat-time)',
        className,
      )}
    >
      {children}
    </div>
  );
};
